import { render, staticRenderFns } from "./FacebookMessengerButton.vue?vue&type=template&id=2ba931b4&scoped=true&"
import script from "./FacebookMessengerButton.vue?vue&type=script&lang=js&"
export * from "./FacebookMessengerButton.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMessengerButton.vue?vue&type=style&index=0&id=2ba931b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba931b4",
  null
  
)

export default component.exports